import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Box, CircularProgress, Typography } from "@mui/material";

import TicketHeader from "./TicketHeader";
import ChatBody from "./ChatBody";
import ChatFooter from "./ChatFooter";

import ITicket from "../@type";
import { AppContext } from "../../../scripts/context/App";

interface IMessage {
  attachment?: string;
  isMine: boolean;
  message: string;
  message_id: number;
  sent_time: string;
  user_avatar: string;
  user_name: string;
}

interface ICategory {
  id: number | string;
  name: string;
}

interface IData {
  ticket_id: number;
  category: ICategory;
  title: string;
  sent_time: string;
  messages: IMessage[];
}

export default function ActiveTicket({ ticket }: { ticket: ITicket }) {
  const {user} = useContext(AppContext);
  const [data, setData] = useState<IData>({
    ticket_id: 0,
    category: {
      id: 0,
      name: "",
    },
    title: "",
    sent_time: "",
    messages: [],
  });
  const [loading, setLoading] = useState<Boolean>(!!ticket.ticket_id);

  useEffect(() => {
    const getTicketDetails = async () => {
      setLoading(true);

      const { data } = await axios.get("/support-tickets/get-ticket-messages", {
        params: {
          ticket_id: ticket.ticket_id,
        },
      });

      setData(data.data);
      setLoading(false);
    };

    ticket.ticket_id && getTicketDetails();
  }, [ticket.ticket_id]);

  return (
    <Box sx={{ width: "100%" }}>
      <TicketHeader ticketSenderData={ticket} setTicket={setData} ticket={data} />

      {ticket.ticket_id ? (
        <ChatBody messages={data.messages} loading={loading} />
      ) : (
        <Box
          sx={{
            width: "100%",
            maxHeight: "60vh",
            minHeight: "60vh",
            overflow: "auto",
            display: "grid",
            placeContent: "center",
          }}
        >
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Select a ticket to view chat
          </Typography>
        </Box>
      )}

      {user.permissions.includes("reply_ticket") ? <ChatFooter
        ticket={data}
        updateTicket={(object: any) => setData({ ...data, ...object })}
      /> : (
        <Box>
          <Typography variant="h6" sx={{ textAlign: "center", pt: 2, m: 0 }}>
            You don't have permission to reply to tickets
          </Typography>
        </Box>
      )}
    </Box>
  );
}
